import Service from "../../Services";

const ServiceMenu = {
    namespaced : true,
    state : {
        service_menu : [],
        membership : [],
        membership_main : null,
        member_tcdc : [],
        membership_rate : [],
        membership_benefit : [],
        travel_info : [],
        resource_center_main : null,
        resource_center : [],
        venture_hire : null,
        service_area : null,
        restaurant : null,
        group_visit : null,
        location : null,
        service_area_floors : [],
        banner : null,
        resource_centers : {
            resource_center : null,
            material : null,
            database : null,
        }
    },
    mutations : {
        SET_SERVICE_MENU : (state,res)=>{
            state.service_menu = res.service_menu;
            state.resource_center_main = res.resource_center_main;
            state.membership_main = res.membership_main;
            state.membership = res.membership;
            state.member_tcdc = res.member_tcdc;
            state.membership_rate = res.membership_rate;
            state.membership_benefit = res.membership_benefit;
            state.travel_info = res.travel_info;
            state.venture_hire = res.venture_hire;
            state.service_area = res.service_area;
            state.restaurant = res.restaurant;
            state.group_visit = res.group_visit;
            state.location = res.location;
            state.service_area_floors = res.service_area_floors;
            state.banner = res.banner;
        },
        SET_MEMBERSHIP_RATE : (state,res)=>{
            state.membership_rate = res;
        },
        SET_RESOURCE_CENTER : (state,res)=>{
            state.resource_center = [
                ...res.resource_center.map(resource=>({
                    id : resource.id + 10,
                    slug : resource.slug_url,
                    title_th : resource.title_th,
                    title_en : resource.title_en,
                    data: resource,
                })),
                {
                    id: "4",
                    slug: "article",
                    title_th: "บทความ",
                    title_en: "Article",
                    data: null,
                },
                {
                    id: "5",
                    slug: "ebook",
                    title_th: "E-book",
                    title_en: "E-book",
                    data: null,
                },
                {
                    id: "6",
                    slug: "online-exhibition",
                    title_th: "นิทรรศการออนไลน์",
                    title_en: "Online exhibition",
                    data: null,
                },
                {
                    id: "7",
                    slug: "design-world-calendar",
                    title_th: "Design world calendar",
                    title_en: "Design world calendar",
                    data: null,
                }
            ];
        },
        SET_RESOURCE_CENTER_DATA : (state,resource)=>{
            if(resource && resource.slug_url.includes('material')){
                state.resource_centers.material = resource;
            }
            if(resource && resource.slug_url.includes('database')){
                state.resource_centers.database = resource;
            }
            if(resource && resource.slug_url.includes('tcdc-resource-center')){
                state.resource_centers.resource_center = resource;
            }
            // console.log(state.resource_centers);
        }

    },
    actions : {
      getServiceMenuByBranch({commit},{branch_id, lang}) {
          return Service.ServiceMenuAPI.getServiceMenuByBranch(branch_id,lang).then(res=>{
              commit('SET_SERVICE_MENU',res);
              commit('SET_RESOURCE_CENTER',res);
          })
      },
        getMembershipRateByBranch({commit},{id, lang}) {
            return Service.ServiceMenuAPI.getMembershipRateByBranch(id,lang).then(res=>{
                commit('SET_MEMBERSHIP_RATE',res);
            })
        },
        setResourceCenterData({commit},data){
          commit('SET_RESOURCE_CENTER_DATA',data);
        }
    },
}
export default ServiceMenu
